import { useEffect, useState } from "react";
import { useRouter } from "next/router";

/**
 * Thin gradient trickle bar pinned to the top of the viewport during route changes --
 * a hand-rolled NProgress-style preloader (no extra dependency) that hands off cleanly
 * into _app.js's page-transition fade once the new page is ready.
 */
const RouteProgressBar = () => {
  const router = useRouter();
  const [phase, setPhase] = useState("idle"); // idle | loading | done

  useEffect(() => {
    const start = () => setPhase("loading");

    const finish = () => {
      setPhase("done");
      window.setTimeout(() => setPhase("idle"), 260);
    };

    router.events.on("routeChangeStart", start);
    router.events.on("routeChangeComplete", finish);
    router.events.on("routeChangeError", finish);

    return () => {
      router.events.off("routeChangeStart", start);
      router.events.off("routeChangeComplete", finish);
      router.events.off("routeChangeError", finish);
    };
  }, [router.events]);

  if (phase === "idle") return null;

  return (
    <div className="rbt-route-progress" aria-hidden="true">
      <span className={`rbt-route-progress__bar rbt-route-progress__bar--${phase}`} />
    </div>
  );
};

export default RouteProgressBar;
